/** Typographic quotes and their ASCII forms — folded together for the key. */
const CURLY_QUOTES = /[‘’“”]/gu;

/**
 * Flatten typographic quotes to their ASCII forms. EVERY `aiCache` key goes
 * through this — `quoteLower` here, `selectionHash` in `selection.ts` — so a
 * selection is one cache row whether the text it came from was educated
 * (`curlQuotes`) or authored straight. Nothing else about the text changes;
 * the displayed `quote` column keeps the reader's own marks.
 */
export function foldTypographicQuotes(text: string): string {
  return text.replace(CURLY_QUOTES, (q) =>
    q === "‘" || q === "’" ? "'" : '"',
  );
}

/**
 * Casefold a source word to its canonical index form: NFC (polytonic Greek
 * has composed/decomposed spellings of the same letters) + lowercase + ASCII
 * quotes. The ONE function both the `quoteLower` column write and every
 * consensus lookup go through, so the two can never disagree.
 *
 * The quote fold is what keeps this cache addressable across the reader's
 * typographic quotes (`curlQuotes` educates the displayed text, so a selection
 * arrives as `don’t`) and the straight quotes the corpus is authored in — and
 * across books whose source is already curly. Two spellings of one word must
 * not be two cache rows, each paying for its own Anthropic call.
 */
export function foldQuote(quote: string): string {
  return foldTypographicQuotes(quote.normalize("NFC").toLowerCase());
}
